import React, { useState } from 'react';

interface StepProps {
  recordId: string; // The record ID passed to the component
  handleClose: () => void; // Function to close the popup
  onUpdate: (updatedRecord: any) => void; // Function to handle updates
  handleInputChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void; // Input change handler
  formData: { bidOverrideList?: string }; // The form data (with bidOverrideList as optional)
}

const BidOverridingPopup: React.FC<StepProps> = ({
  recordId,
  handleClose,
  onUpdate,
  handleInputChange,
  formData,
}) => {
  const [sourceId, setSourceId] = useState('');
  const [overrideBid, setOverrideBid] = useState('');

  const handleAdd = () => {
    const newEntry = `${sourceId},${overrideBid}`;
    const updatedList = formData.bidOverrideList ? `${formData.bidOverrideList}\n${newEntry}` : newEntry;
    handleInputChange({
      target: {
        name: 'bidOverrideList',
        value: updatedList,
      },
    } as React.ChangeEvent<HTMLTextAreaElement>);
    setSourceId('');
    setOverrideBid('');
  };

  const handleSave = () => {
    const updatedRecord = {
      recordId,
      bidOverrideList: formData.bidOverrideList || '',
    };
    onUpdate(updatedRecord);
    handleClose();
  };

  return (
    <div className="popup-container">
      <div className="popup-header">
        <h4 style={{ fontSize: '12px' }}>Campaign: Bid Override</h4>
      </div>
      <div className="popup-content">
        <p style={{ fontSize: '12px', color: '#990429', fontWeight: '500' }}>
          Please use the following tool with caution and make sure you are tracking your campaign well and that you
          know what you are doing. If needed, please consult our support team.
        </p>
        <p style={{ fontSize: '12px' }}>
          Bid Override gives you better control over your origins of traffic. Each of our traffic sources has its own ID
          and using the tool below you can set specific bid (either lower or higher than the default one that you have
          set for this ad).
          <br></br>
          You may wish to set higher bids for high-performing subids (so you can win more traffic) and lower bids for
          less-performing subids (so you pay less for the traffic that you get).
        </p>
        <p style={{ fontSize: '12px', color: '#990429', fontWeight: '500' }}>
          Please take extra caution and make sure you are only using the IDs passed to your Target URL by the <strong>{"{BV_SRCID}"}</strong> Macro.
        </p>

        <div>
            <p style={{fontWeight:'500', fontSize:'11px', marginLeft:'5px'}}>Simply type below the subid and the bid that you wish to set:            </p>
            </div>
         
        <div style={{ marginLeft:'5px',display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '20px' }}>
            
          <label htmlFor="sourceId" style={{ fontSize: '12px', fontWeight: '500' }}>Source ID:</label>
          <input
            type="text"
            id="sourceId"
            value={sourceId}
            onChange={(e) => setSourceId(e.target.value)}
            style={{
              padding: '10px 0px',
            //   flex: 1,
              fontSize: '12px',
              border: '1px solid lightgray',
            }}
          />
          <label  style={{ fontSize: '12px', fontWeight: '500' }}>Override Bid:</label>
          <input
            type="text"
            id="overrideBid"
            value={overrideBid}
            onChange={(e) => setOverrideBid(e.target.value)}
            style={{
                padding: '10px 0px',            //   flex: 1,
              fontSize: '12px',
              border: '1px solid lightgray',
              
            }}
          />
          <button
            onClick={handleAdd}
            style={{
              padding: '7px 40px',
              backgroundColor: '#1173B7',
              color: 'white',
              fontSize: '12px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Add
          </button>
        </div>

        <label htmlFor="bidOverrideList" style={{marginLeft:'5px', display: 'block', marginBottom: '10px', fontWeight: '500', fontSize: '12px', color: '#990429' }}>
          Bid Override List:
        </label>
        <textarea
          id="bidOverrideList"
          name="bidOverrideList"
          value={formData.bidOverrideList || ''}
          onChange={handleInputChange}
          rows={8}
          style={{
            marginLeft:'5px',
            width: '50%',
            height: '250px',
            padding: '10px',
            fontSize: '12px',
            border: '1px solid lightgray',
            borderRadius: '5px',
          }}
        />
      </div>
      <div className="popup-actions" style={{ textAlign: 'center', marginTop: '20px' }}>
        <button
          onClick={handleSave}
          style={{
            padding: '7px 40px',
            backgroundColor: '#1173B7',
            color: 'white',
            fontSize: '12px',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default BidOverridingPopup;